import {MARKETING_API_BASE_URL, MYEDUPLUS_API_BASE_URL} from "../environment";

export const CREDENTIALS_REQUEST_BASE_URL = `${MARKETING_API_BASE_URL}credentials-requests/`;
export const CREDENTIALS_REQUEST_VERIFY_BASE_URL = `${CREDENTIALS_REQUEST_BASE_URL}verify-phone-number/`;

export const TEAM_SETTINGS_BASE_URL = `${MYEDUPLUS_API_BASE_URL}/api/settings/team-page-contents`;